import { l10n } from '@ott/l10n';

import makeMask from '../helpers/makeMask';

const mask = makeMask();

export default function formatBirthdate(v) {
  return mask.call(this, v, formatBirthdate.mask, formatBirthdate.placeholder);
}

const dateMask = l10n('common.dateMask');
const datePattern = '99.99.9999';

formatBirthdate.placeholder = dateMask;
formatBirthdate.mask = datePattern;
